/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum FetchDataType {
    ExamFlow = 1,
    Media = 2,
    TrainingRoom = 3,
    Scenario = 4,
    SimUser = 5,
    Assessment = 6,
    Event = 7,
    SimGroup = 8,
    Course = 9,
}
